module.exports = __webpack_public_path__ + "static/media/asurion-protect-it-mobile.571d44f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/asurion-protect-it-mobile.jpg
// module id = 952
// module chunks = 0